import * as React from 'react';
import * as _ from 'lodash';
import ChildrenFader from '../../shared/components/ChildrenFader';
import PhotosPicker from '../../shared/components/PhotosPicker';
import TextBubble from '../../shared/components/TextBubble';
import CollapsingWrapper from '../../shared/components/CollapsingWrapper/CollapsingWrapper';
import {withStyles, createStyles} from '@material-ui/core/styles';
import {WithStyles} from '@material-ui/core/styles/withStyles';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {FIELD_WIDTH} from '../../MyAccount/Listings/EbayListing/consts';
import {fromJS} from 'immutable';
import {FormControl} from '@material-ui/core';

const CURRENT_GROUP_SELECT_NAME = 'currentGroup';

export interface URLsObj {
  [key: string]: string[];
}
export interface PhotosPickerGroupsObj {
  [key: string]: URLsObj;
}
export interface PhotosPickerGroupBaseProps {
  fieldName: string;
}
interface PhotosPickerGroupProps extends PhotosPickerGroupBaseProps {
  picturesURLsGroup: PhotosPickerGroupsObj;
  currentGroup: string;
  maxPhotosAllowed: number;
  updatePhotosGroup: (
    event: object,
    group: string,
    variationName?: string,
    reorder?: boolean,
    deletion?: boolean
  ) => void;
  groupPickerText: string;
  groupsNames?: string[];
  id?: string;
}

class PhotosPickerGroup extends React.PureComponent<PhotosPickerGroupProps & WithStyles<typeof styles>> {
  handleChange = (variationName, value, reorder, deletion) => {
    const {updatePhotosGroup, picturesURLsGroup, currentGroup} = this.props;
    const picturesURLsGroupCopy = fromJS(picturesURLsGroup).toJS();
    picturesURLsGroupCopy[currentGroup][variationName] = value;
    updatePhotosGroup(picturesURLsGroupCopy, currentGroup, variationName, reorder, deletion);
  };

  updateGroup = event => {
    const {updatePhotosGroup, picturesURLsGroup} = this.props;
    updatePhotosGroup(picturesURLsGroup, event.target.value);
  };

  renderDropdown() {
    const {
      currentGroup,
      groupPickerText,
      picturesURLsGroup,
      id,
      classes: {selectContainer, selectExplanation, selectLabel, selectWidth},
    } = this.props;
    let {groupsNames} = this.props;
    if (_.isUndefined(groupsNames)) {
      groupsNames = _.keys(picturesURLsGroup);
    }
    return (
      <div className={selectContainer}>
        <div className={selectLabel}>{groupPickerText}</div>
        <FormControl id={`${id}-form`} disabled={_.size(groupsNames) === 1}>
          <Select
            value={currentGroup}
            onChange={this.updateGroup}
            name={CURRENT_GROUP_SELECT_NAME}
            classes={{root: selectWidth}}
          >
            {_.map(groupsNames, (name, index) => (
              <MenuItem id={`cla-menu-itm-${index}`} key={index} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <span className={selectExplanation}>This determines which photos buyers see when they select a variation.</span>
      </div>
    );
  }

  getPhotosAmountLeft(sectionName) {
    const {picturesURLsGroup, maxPhotosAllowed, currentGroup} = this.props;
    return maxPhotosAllowed - _.size(picturesURLsGroup[currentGroup][sectionName]);
  }

  render() {
    const {
      picturesURLsGroup,
      maxPhotosAllowed,
      currentGroup,
      id,
      classes: {photosPickerGroupContainer, photosPickerContainer, flexContainer},
      ...other
    } = this.props;
    const keyPrefix = 'Photos_Picker_Group_';
    const sectionNames = _.keys(picturesURLsGroup[currentGroup]);
    return (
      <div className={photosPickerGroupContainer}>
        {this.renderDropdown()}
        {_.map(sectionNames, (sectionName, index) => {
          const URLs = picturesURLsGroup[currentGroup][sectionName];
          return (
            <CollapsingWrapper
              id={`${id}-${index}`}
              key={sectionName}
              title={
                <div key={sectionName} className={flexContainer}>
                  {sectionName}
                  <ChildrenFader>
                    <TextBubble className="cla-image-count" text={URLs.length} />
                  </ChildrenFader>
                </div>
              }
              defaultOpen={true}
            >
              <div key={sectionName} className={photosPickerContainer}>
                <PhotosPicker
                  id={`${id}-${index}`}
                  key={keyPrefix + sectionName}
                  picturesURLs={URLs}
                  photosAmountLeft={this.getPhotosAmountLeft(sectionName)}
                  maxPhotosAllowed={maxPhotosAllowed}
                  updatePicturesURLs={(value, reorder, deletion) =>
                    this.handleChange(sectionName, value, reorder, deletion)
                  }
                  uniqueIdForUploadDialog={keyPrefix + sectionName}
                  {...other}
                />
              </div>
            </CollapsingWrapper>
          );
        })}
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    photosPickerGroupContainer: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      flex: '1',
    },
    photosPickerContainer: {
      padding: theme.spacing(2),
    },
    flexContainer: {
      display: 'flex',
    },
    selectExplanation: {
      color: theme.palette.text.secondary,
      paddingLeft: theme.spacing(2),
    },
    selectContainer: {
      display: 'flex',
      alignItems: 'baseline',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
    },
    selectLabel: {
      flexGrow: 0,
      flexShrink: 0,
      paddingRight: theme.spacing(2),
    },
    selectWidth: {
      minWidth: FIELD_WIDTH.S,
    },
  });

export default withStyles(styles)(PhotosPickerGroup);
